import axiosInstance from 'client';
import * as dto from 'client/dto';

export type GetDiseaseActivityApiPayload = {
  countryId?: number;
  diseaseId?: number;
  speciesId?: number;
  activityStartDate: string;
  activityEndDate?: string;
  userLocationId?: number;
};

export type GetCalculationBreakdownApiPayload = {
  countryId: number;
  diseaseId: number;
  speciesId: number;
  userLocationId: number;
};

function DiseaseActivityController_GetDiseaseActivities(
  payload: GetDiseaseActivityApiPayload
): Promise<dto.GetEventListModel> {
  const { activityStartDate, activityEndDate, diseaseId, userLocationId } = payload;
  return axiosInstance
    .get(`/api/activity`, {
      params: { activityStartDate, activityEndDate, diseaseId, userLocationId },
    })
    .then(({ data }) => data);
}

function DiseaseActivityController_GetDiseaseActivity(
  payload: GetDiseaseActivityApiPayload
): Promise<dto.GetEventModel> {
  const {
    countryId,
    diseaseId,
    speciesId,
    activityStartDate,
    activityEndDate,
    userLocationId,
  } = payload;
  return axiosInstance
    .get(`/api/activity/disease/${diseaseId}/species/${speciesId}/country/${countryId}`, {
      params: {
        countryId,
        diseaseId,
        speciesId,
        activityStartDate,
        activityEndDate,
        userLocationId,
      },
      headers: { 'X-Entity-Type': 'GetEventModel' },
    })
    .then(({ data }) => data);
}

function DiseaseActivityController_GetCalculationBreakdown(
  payload: GetCalculationBreakdownApiPayload
): Promise<dto.CalculationBreakdownModel> {
  const { countryId, diseaseId, speciesId, userLocationId } = payload;
  return axiosInstance
    .get(`/api/activity/disease/${diseaseId}/species/${speciesId}/country/${countryId}/risk`, {
      params: { countryId, diseaseId, speciesId, userLocationId },
      headers: { 'X-Entity-Type': 'CalculationBreakdownModel' },
    })
    .then(({ data }) => data);
}

function DiseaseActivityController_GetAirports(payload: {
  countryId: number;
  diseaseId: number;
  speciesId: number;
  userLocationId: number;
}): Promise<dto.EventAirportModel> {
  const { countryId, diseaseId, speciesId, userLocationId } = payload;
  return axiosInstance
    .get(`/api/activity/disease/${diseaseId}/species/${speciesId}/country/${countryId}/airport`, {
      params: { countryId, diseaseId, speciesId, userLocationId },
      headers: { 'X-Entity-Type': 'EventAirportModel' },
    })
    .then(({ data }) => data);
}

export default {
  DiseaseActivityController_GetDiseaseActivities,
  DiseaseActivityController_GetDiseaseActivity,
  DiseaseActivityController_GetCalculationBreakdown,
  DiseaseActivityController_GetAirports,
};
